<template>
  <section class="space-y-12">

    <!-- ================= HEADER ================= -->
    <div class="flex items-end justify-between">

      <div>
        <h1 class="text-4xl font-extrabold tracking-tight text-slate-900">
          Audience Intelligence
        </h1>

        <p class="text-slate-400 font-medium mt-1">
          Verified audience insights you own and control.
        </p>
      </div>

      <!-- Total Audience -->
      <div class="text-right">

        <p class="text-[11px] uppercase tracking-widest text-slate-400 font-bold">
          Total Audience
        </p>

        <h2 v-if="kpis.length>0" class="text-4xl font-black text-slate-900">
          {{ kpis[0].value }}
        </h2>

      </div>

    </div>

    <!-- ================= KPI STRIP ================= -->
    <!-- <section class="grid grid-cols-1 md:grid-cols-4 gap-8">
      <div v-for="item in kpis" :key="item.label"
        class="bg-white p-8 rounded-3xl premium-shadow border border-slate-50">
        <p class="text-[11px] font-bold uppercase tracking-widest text-slate-400">
          {{ item.label }}
        </p>

        <h2 class="text-4xl font-black tracking-tight mt-2">
          {{ item.value }}
          <span v-if="item.suffix" class="text-lg opacity-30">
            {{ item.suffix }}
          </span>
        </h2>

        <p v-if="item.note" class="text-xs text-slate-400 mt-2">
          {{ item.note }}
        </p>
      </div>
    </section> -->

    <section class="grid grid-cols-1 lg:grid-cols-2 gap-10">

      <!-- Gender Donut -->
      <div class="bg-white p-8 rounded-3xl premium-shadow border border-slate-50">
        <h3 class="text-lg font-bold mb-6">Audience Gender</h3>
        <div id="genderChart"></div>
      </div>

      <!-- Age Range -->
      <div class="bg-white p-8 rounded-3xl premium-shadow border border-slate-50">
        <h3 class="text-lg font-bold mb-6">Age Distribution</h3>
        <div id="ageChart"></div>
      </div>


    </section>


    <section class="grid grid-cols-1 lg:grid-cols-3 gap-10">

      <!-- City Tier -->
      <div class="bg-white p-8 rounded-3xl premium-shadow border border-slate-50">
        <h3 class="text-lg font-bold mb-6">City Tier Distribution</h3>
        <div id="cityChart"></div>
      </div>

      <!-- Platform -->
      <div class="bg-white p-8 rounded-3xl premium-shadow border border-slate-50">
        <h3 class="text-lg font-bold mb-6">Platform Distribution</h3>
        <div id="platformChart"></div>
      </div>

      <!-- Niche -->
      <div class="bg-white p-8 rounded-3xl premium-shadow border border-slate-50">
        <h3 class="text-lg font-bold mb-6">Creator Niche</h3>
        <div id="nicheChart"></div>
      </div>

    </section>

    <!-- <section class="bg-white p-8 rounded-[2rem] premium-shadow border border-slate-50
            flex flex-col md:flex-row md:items-center md:justify-between gap-6">

        <div>
          <p class="text-[11px] font-bold uppercase tracking-[0.15em] text-slate-400">
            Your Invite Link
          </p>
          <p class="mt-2 text-sm font-mono text-slate-700 break-all">
            {{ inviteLink }}
          </p>
          <p class="mt-2 text-xs text-slate-400">
            Share this link in your bio or posts to grow your owned audience.
          </p>
        </div>

        <button
          @click="copyInviteLink"
          class="bg-primary text-white font-bold px-8 py-4 rounded-xl
                flex items-center gap-2 text-xs uppercase tracking-wider
                hover:opacity-90 transition-all w-fit"
        >
          <i class='bx bx-copy text-sm'></i>
          Copy Link
        </button>

      </section> -->

    <!-- ================= AUDIENCE TABLE ================= -->
    <!-- ================= AUDIENCE CARDS ================= -->
    <section class="border border-slate-50 p-8">

      <!-- Header -->
      <div class="flex justify-between items-center mb-8">
        <h3 class="text-lg font-bold text-slate-900">
          Verified Audience List
        </h3>

        <span class="text-xs font-bold text-slate-400 uppercase tracking-widest">
          Page {{ currentPage + 1 }} of {{ totalPages }}
        </span>
      </div>

      <!-- Cards Grid -->
      <div v-if="paginatedFans.length" class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">

        <div v-for="fan in paginatedFans" :key="fan.user_id"
          class="group border border-slate-100 rounded-2xl p-6 hover:shadow-xl hover:-translate-y-1 transition-all duration-300 bg-gradient-to-br from-white to-slate-50">

          <!-- Top -->
          <div class="flex justify-between items-start">
            <div>
              <p class="text-[10px] font-bold uppercase tracking-widest text-slate-400">
                Fan ID
              </p>
              <h4 class="font-bold text-slate-900 text-lg mt-1">
                FAN33443{{ fan.user_id }}
              </h4>
            </div>

            <span v-if="fan.user_email_verified==='yes'"
              class="px-3 py-1 text-xs font-bold rounded-full bg-emerald-50 text-emerald-700">
              Verified
            </span>
            <span v-if="fan.user_email_verified==='no'"
              class="px-3 py-1 text-xs font-bold rounded-full bg-red-50 text-red-700">
              Not Verified
            </span>
          </div>

          <!-- Divider -->
          <div class="h-px bg-slate-100 my-5"></div>

          <!-- Info -->
          <div class="space-y-2">
            <p class="text-sm font-semibold text-slate-800">
              {{ fan.user_name }}
            </p>

            <!-- <p v-if="fan.user_email" class="text-xs text-slate-500">
              {{ fan.user_email }}
            </p>

            <p v-if="fan.user_mobile" class="text-xs text-slate-400">
              {{ fan.user_mobile }}
            </p> -->
          </div>

          <!-- Optional Actions -->
          <!-- <div class="mt-6 flex justify-between items-center opacity-0 group-hover:opacity-100 transition">
            <button class="text-xs font-bold uppercase tracking-widest text-slate-600 hover:text-black">
              View
            </button>

            <button class="text-xs font-bold uppercase tracking-widest text-red-500 hover:text-red-700">
              Remove
            </button>
          </div> -->

        </div>

      </div>

      <!-- Empty State -->
      <div v-else class="text-center py-20 text-slate-400">
        No audience members yet.
      </div>

      <!-- Pagination -->
      <div class="flex justify-between items-center mt-10">
        <button class="pagination-btn" :disabled="currentPage === 0" @click="prevPage">
          ← Previous
        </button>

        <button class="pagination-btn" :disabled="currentPage + 1 >= totalPages" @click="nextPage">
          Next →
        </button>
      </div>

    </section>

  </section>
</template>

<script>
  import ApexCharts from "apexcharts";
  import { useToast } from "vue-toastification";
  import { mainBaseUrl } from "../apis/appconst";

  import {
    getAudienceKpisApi,
    getAudienceListApi
  } from "../apis/influencerapis";

  export default {
    name: "AudienceScreen",

    data() {
      return {
        cityGraph: null,
        platformGraph: null,
        nicheGraph: null,

        cityChart: null,
        platformChart: null,
        nicheChart: null,
        inviteLink: "",

        kpis: [],

        fans: [],

        currentPage: 0,     // IMPORTANT → matches backend pagination
        perPage: 10,
        total: 0,

        loading: false,
        toast: null,
        user: null,
        genderChart: null,
        ageChart: null,

        genderGraph: null,
        ageGraph: null,
      };
    },

    async mounted() {

      this.toast = useToast();

      const ldataRaw = sessionStorage.getItem("ldata");
      this.user = ldataRaw ? JSON.parse(ldataRaw) : null;

      if (!this.user || !this.user.user_id) {
        window.location.href = "/login";
        return;
      }
      this.inviteLink = mainBaseUrl + "join/" + this.user.user_id;

      await this.loadKpis();
      await this.loadFans();
    },

    methods: {

      // ================= KPIs =================
      async loadKpis() {

        const res = await getAudienceKpisApi(this.user.user_id);

        if (!res.status) {
          this.toast.error(res.success || "Failed to load KPIs");
          return;
        }

        this.kpis = res.kpis || [];

        this.genderGraph = res.gender_graph;
        this.ageGraph = res.age_graph;
        this.cityGraph = res.city_graph;
        this.platformGraph = res.platform_graph;
        this.nicheGraph = res.niche_graph;

        this.initGenderChart();
        this.initAgeChart();
        this.initCityChart();
        this.initPlatformChart();
        this.initNicheChart();
      },
      initGenderChart() {

        const el = document.querySelector("#genderChart");
        if (!el || !this.genderGraph) return;

        if (this.genderChart) {
          this.genderChart.destroy();
        }

        this.genderChart = new ApexCharts(el, {

          chart: {
            type: "donut",
            height: 260
          },

          series: this.genderGraph.values,

          labels: this.genderGraph.labels,

          legend: {
            position: "bottom"
          },

          colors: ["#0f172a", "#6366f1", "#f59e0b"],

          dataLabels: {
            enabled: false
          }

        });

        this.genderChart.render();
      },
      initAgeChart() {

        const el = document.querySelector("#ageChart");
        if (!el || !this.ageGraph) return;

        if (this.ageChart) {
          this.ageChart.destroy();
        }

        this.ageChart = new ApexCharts(el, {

          chart: {
            type: "bar",
            height: 260,
            toolbar: { show: false }
          },

          series: [
            {
              name: "Fans",
              data: this.ageGraph.values
            }
          ],

          xaxis: {
            categories: this.ageGraph.labels
          },

          plotOptions: {
            bar: {
              horizontal: true,
              borderRadius: 6,
              barHeight: "50%",
              distributed: true   // ✅ this makes each bar a different color
            }
          },

          colors: [
            "#0f172a",
            "#6366f1",
            "#22c55e",
            "#f59e0b",
            "#ef4444",
            "#06b6d4"
          ],

          dataLabels: {
            enabled: true
          },

          grid: {
            strokeDashArray: 4
          }

        });

        this.ageChart.render();
      },

      initCityChart() {

        const el = document.querySelector("#cityChart");
        if (!el || !this.cityGraph) return;

        this.cityChart = new ApexCharts(el, {

          chart: { type: "bar", height: 260 },

          series: [{
            name: "Fans",
            data: this.cityGraph.values
          }],

          xaxis: {
            categories: this.cityGraph.labels
          },

          colors: ["#6366f1"],

          dataLabels: { enabled: true }

        });

        this.cityChart.render();
      },
      initPlatformChart() {

        const el = document.querySelector("#platformChart");
        if (!el || !this.platformGraph) return;

        this.platformChart = new ApexCharts(el, {

          chart: { type: "donut", height: 260 },

          series: this.platformGraph.values,

          labels: this.platformGraph.labels,

          legend: { position: "bottom" },

          colors: ["#f43f5e", "#6366f1", "#0f172a", "#f59e0b"],

          dataLabels: { enabled: false }

        });

        this.platformChart.render();
      },
      initNicheChart() {

        const el = document.querySelector("#nicheChart");
        if (!el || !this.nicheGraph) return;

        this.nicheChart = new ApexCharts(el, {

          chart: { type: "bar", height: 260 },

          series: [{
            name: "Creators",
            data: this.nicheGraph.values
          }],

          xaxis: {
            categories: this.nicheGraph.labels
          },

          colors: ["#0f172a"],

          dataLabels: { enabled: true }

        });

        this.nicheChart.render();
      },
      // ================= FAN LIST =================
      async loadFans() {

        if (this.loading) return;

        this.loading = true;

        const res = await getAudienceListApi(
          this.user.user_id,
          this.currentPage
        );

        this.loading = false;

        if (!res.status) {
          this.toast.error(res.success || "Failed to load audience");
          return;
        }

        this.fans = res.fans || [];
        this.total = res.total || 0;
      },

      // ================= PAGINATION =================
      async nextPage() {

        if (this.currentPage + 1 >= this.totalPages) return;

        this.currentPage++;
        await this.loadFans();
      },

      async prevPage() {

        if (this.currentPage === 0) return;

        this.currentPage--;
        await this.loadFans();
      },

      // ================= COPY LINK =================
      copyInviteLink() {

        navigator.clipboard.writeText(this.inviteLink);

        this.toast.success("Invite link copied!", {
          timeout: 2000,
          closeOnClick: true
        });
      }
    },

    computed: {

      totalPages() {
        return Math.ceil(this.total / this.perPage);
      },

      paginatedFans() {
        return this.fans;
      }
    }
  };
</script>


<style scoped>
  /* Premium card shadow */
  .premium-shadow {
    box-shadow: 0 8px 40px -12px rgba(0, 0, 0, 0.08);
  }

  /* Action buttons */
  .action-btn {
    font-size: 12px;
    font-weight: 700;
    color: #0f172a;
    border-bottom: 2px solid transparent;
  }

  .action-btn:hover {
    border-color: #0f172a;
  }

  /* Pagination buttons */
  .pagination-btn {
    font-size: 12px;
    font-weight: 700;
    text-transform: uppercase;
    color: #0f172a;
  }

  .pagination-btn:disabled {
    opacity: 0.3;
    cursor: not-allowed;
  }
</style>